export default __webpack_public_path__ + "static/media/hero-art.443f5a58.png";